import { graphql } from "@/graphql/codegen/gql"

graphql(`
  mutation UpdateAccountingSettings($input: UpdateAccountingSettingsInput!) {
    accountingSettings {
      update(input: $input) {
        __typename
        ... on UpdateAccountingSettingsSuccess {
          settings {
            paymentByAchOrVirtualCcLeadDays
            paymentByCheckLeadDays
            paymentByWireLeadDays
          }
        }
        ... on UpdateAccountingSettingsFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
